import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc93 = {
    title: "Image 93: Examples of Quiet Rooms.",
    para1: <>
        <p>The image shows two pictures of a Quiet/Sensory Room.</p>
        <p>The image on the left shows the Sensory Room from the outside with the inside of the room being partially visible. There is a board next to the entrance that reads “Sensory Room”. The image partially shows a sensory board and a bean bag inside the room.</p>
        <p>The image on the right shows the inside of the Sensory Room. The wall panel is in the shape of an aeroplane which is blue and has several different sensory games on it. The room has two bean bags on the floor. There is a screen on the wall on the left side of the room which is lit up with blue lights.</p>
    </>,
}

export const FigureDesc71 = {
    title: "Figure 71: Typical floor plan of a quiet room/sensory room.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The figure shows a floor plan for a quiet/sensory room. An entrance is provided at the bottom-right of the layout. The room is wheelchair-accessible, with a turning diameter of 1500 mm.
        </p>
        <p>The features of the space are described in a clockwise manner. </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance door leading to the quiet room/sensory room is provided at the bottom-right of the layout.",
                    "All sides of the room are provided with acoustically treated walls. Sensory lighting is additionally provided along the bottom wall.",
                    "A two-seater couch is provided at the bottom-left of the layout.",
                    "A window is provided along the left wall.",
                    "Directly opposite the couch and at the top-left of the layout, a sensory board is provided to ensure a calm and soothing sensory experience.",
                    "Next to the sensory board, a bean bag has been provided.",
                    "At the top-right of the layout, a table has been provided upon which a noise-cancelling headphone is placed. Green plants are also provided to ensure comfort.",

                ])}
            </div>
        </p>
    </>
}

